import {WorkflowStatusTypeModel} from './workflow-status-type.model';
import {WorkflowStepModel} from './workflow-step.model';

export class WorkflowInstanceModel {
    public id: number;
    public workflowId: number;
    public name: string;
    public workflowStatusTypeID: number;
    public workflowStatus: WorkflowStatusTypeModel;
    public readySteps: WorkflowStepModel[];
    public version: string;
}
